import React from "react";
import { useNavigate } from "react-router-dom";
import line1 from "../../assets/line1.svg";
import line2 from "../../assets/line2.svg";
import line3 from "../../assets/line3.svg";
import Shape from "../Shape/Shape";
import shape1 from "../../assets/shape1.svg";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";
import "./OrderSection.css";

const OrderSection = () => {
  const navigate = useNavigate();

  const handleOrderClick = () => {
    navigate("/contact");
  };

  return (
    <section className="order-section">
      <div className="animated-lines">
        <div className="line-wrapper">
          <img src={line1} alt="Line 1" className="animated-line" />
          <img src={line1} alt="Line 1 Duplicate" className="animated-line" />
        </div>
        <div className="line-wrapper reverse">
          <img src={line2} alt="Line 2" className="animated-line" />
          <img src={line2} alt="Line 2 Duplicate" className="animated-line" />
        </div>
        <div className="line-wrapper">
          <img src={line3} alt="Line 3" className="animated-line" />
          <img src={line3} alt="Line 3 Duplicate" className="animated-line" />
        </div>
      </div>
      <div className="order-content">
        <h2>Ready to Unwrap the Joy?</h2>
        <h3>
          Order and Make Your
          <br /> Day Happy!
        </h3>
        <button className="order-button" onClick={handleOrderClick}>
          Order Now
        </button>
      </div>
      <Shape svgPath={shape1} className="order-shape1" />
      <Shape svgPath={shape2} className="order-shape2" />
      <Shape svgPath={shape3} className="order-shape3" />
    </section>
  );
};

export default OrderSection;
